import { BenatskaPage } from 'pages/custom/BenatskaPage';
import { BMPage } from 'pages/custom/BMPage';
import { ChacharPage } from 'pages/custom/ChacharPage';
import { ExtremePage } from 'pages/custom/ExtremePage';
import { FjellseterPage } from 'pages/custom/FjellseterPage';
import { FjellsportFestivalPage } from 'pages/custom/FjellsportFestivalPage';
import { FredrikstadPage } from 'pages/custom/FredrikstadPage';
import { GFestivalPage } from 'pages/custom/GFestivalPage';
import { HolesovickaTrzniceDemoPage } from 'pages/custom/HolesovickaTrzniceDemoPage';
import { HoymaPage } from 'pages/custom/HoymaPage';
import { JobspinPage } from 'pages/custom/JobspinPage';
import { KDagPage } from 'pages/custom/KDagPage';
import { Kontakt2023Page } from 'pages/custom/Kontakt2023Page';
import { Kontakt2024Page } from 'pages/custom/Kontakt2024Page';
import { OIWPage } from 'pages/custom/OIWPage';
import { OrcaPage } from 'pages/custom/OrcaPage';
import { PerFEKT2025BookingPage } from 'pages/custom/PerFEKT2025BookingPage';
import { PerFEKTPage } from 'pages/custom/PerFEKTPage';
import { RevolvePage } from 'pages/custom/RevolvePage';
import { ScandicPage } from 'pages/custom/ScandicPage';
import { SeefoodPage } from 'pages/custom/SeafoodPage';
import { SeafoodENPage } from 'pages/custom/SeafoodPageEN';
import { TechportPage } from 'pages/custom/TechportPage';
import { TrevareFestivalPage } from 'pages/custom/TrevareFestivalPage';
import { TydalsPage } from 'pages/custom/TydalsPage';
import { UIAPage } from 'pages/custom/UIAPage';
import { VipSenteretPage } from 'pages/custom/VipSenteretPage';
import { useParams } from 'react-router';

export const CustomerPages = (): JSX.Element => {
    const { customId } = useParams() as { customId: string };

    if (!customId) {
        return null;
    } else if (customId === 'uia') {
        return <UIAPage />;
    } else if (customId === 'kontakt2023') {
        return <Kontakt2023Page />;
    } else if (customId === 'kontakt2024') {
        return <Kontakt2024Page />;
    } else if (customId === 'perfekt2023') {
        return <PerFEKTPage />;
    } else if (customId === 'techport') {
        return <TechportPage />;
    } else if (customId === 'trondheimtechport') {
        return <TechportPage />;
    } else if (customId === 'revolve') {
        return <RevolvePage />;
    } else if (customId === 'seafood') {
        return <SeefoodPage />;
    } else if (customId === 'orca') {
        return <OrcaPage />;
    } else if (customId === 'seafood-en') {
        return <SeafoodENPage />;
    } else if (customId === 'kdag') {
        return <KDagPage />;
    } else if (customId === 'startupextreme') {
        return <ExtremePage />;
    } else if (customId === 'jobspin') {
        return <JobspinPage />;
    } else if (customId === 'vipsenteret') {
        return <VipSenteretPage />;
    } else if (customId === 'fjellseter') {
        return <FjellseterPage />;
    } else if (customId === 'benatska') {
        return <BenatskaPage />;
    } else if (customId === 'gfestival') {
        return <GFestivalPage />;
    } else if (customId === 'scandic') {
        return <ScandicPage />;
    } else if (customId === 'tydals') {
        return <TydalsPage />;
    } else if (customId === 'chachar') {
        return <ChacharPage />;
    } else if (customId === 'trznice-demo') {
        return <HolesovickaTrzniceDemoPage />;
    } else if (customId === 'bm') {
        return <BMPage />;
    } else if (customId === 'hoyma') {
        return <HoymaPage />;
    } else if (customId === 'oiw') {
        return <OIWPage />;
    } else if (customId === 'fjellsport') {
        return <FjellsportFestivalPage />;
    } else if (customId === 'fredrikstad') {
        return <FredrikstadPage />;
    } else if (customId === 'trevare') {
        return <TrevareFestivalPage />;
    } else if (customId === 'perfekt2025-booking') {
        return <PerFEKT2025BookingPage />;
    }
};
